export default "/public/app-main/static/image/6301f84d649a849b53fa44afd33c1989.png";